import { createReducer, createActions } from 'reduxsauce';
import { storage } from '../../utils';

export const INITIAL_STATE = {
  alternateAppData: null,
};

const { Types, Creators } = createActions( {
  loginUser: ['data'],
  updateUser: ['data'],
  logoutUser: null,
  alternateAppLoginData: ['alternateAppData'],
} );

const loginUser = ( state, { data } ) => ( { ...state, ...data } );
const updateUser = ( state, { data } ) => ( { ...state, ...data } );
const alternateAppLoginData = ( state, { alternateAppData } ) => (
  { ...state, alternateAppData }
);

const logoutUser = () => {
  storage.clear( 'massphoning:token' );
  return {};
};

export const reducer = createReducer( INITIAL_STATE, {
  [Types.LOGIN_USER]: loginUser,
  [Types.LOGOUT_USER]: logoutUser,
  [Types.UPDATE_USER]: updateUser,
  [Types.ALTERNATE_APP_LOGIN_DATA]: alternateAppLoginData,
} );

export const UserTypes = Types;
export default Creators;
